<template>
  <div
    class="dialog-content"
    style="
      background-color: rgba(41, 155, 255, 0.1);
      width: 100%;
      padding-top: 10px;
    "
  >
    <el-row style="color: #999; margin-left: 20px; margin-bottom: 9px">
      <el-col :span="8">
        <el-radio-group size="small" v-model="radio" @input="radioChange">
          <el-radio-button label="0">预览</el-radio-button>
          <el-radio-button label="1">回放</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="16">
        <div style="display: flex; align-items: center;height: 36px">
        *提示：如要点击切换请等插件加载完成后再切换，否则会出现加载不出的情况！
        </div>
      </el-col>
    </el-row>
    <playVideo ref="playVideo" :cameraIndexCode="cameraIndexCode" v-if="radio === '0'"  />
    <plaaybackVideo ref="playbackVideo" v-if="radio === '1'"  />
  </div>
</template>

<script>
import playVideo from "@/components/component/playVideo.vue";
import plaaybackVideo from "@/components/component/plaaybackVideo.vue";

export default {
  name: "HikCamera",
  props: ["deviceInfo"],
  components: {
    plaaybackVideo,
    playVideo
  },
  data() {
    return {
      // 开门记录
      doorLogs: {},
      page: {
        data: {
          max: 10,
          index: 1,
        },
      },
      radio: "0",
      playMode: 0, // 播放模式
      cameraIndexCode: '6f231f5c78b644e09e254c16d11cb237'
    };
  },
  mounted() {
    if (this.deviceInfo.note) {
      this.cameraIndexCode = this.deviceInfo.note;
    }
    console.log(this.deviceInfo, 'this.deviceInfo--- note')
  },
  destroyed() {
    if (this.$refs.playVideo) {
      this.$refs.playVideo.destroy();
    }
    if (this.$refs.playbackVideo) {
      this.$refs.playbackVideo.destroy();
    }
  },
  methods: {
    radioChange(e) {
      console.log(e, "ee");
      if (e === "0") {
        this.playMode = 0;
        this.startPreview();
      } else {
        this.playMode = 1;
        this.startPlayback();
      }
    },
    startPreview() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.playVideo.previewVideo(this.cameraIndexCode); // 调用子组件的方法
        }, 2000);
      });
    },
    startPlayback() {
      // 获取当前日期
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要加1
      const day = String(today.getDate()).padStart(2, "0");

      // 构造开始和结束时间
      const beginTime = `${year}-${month}-${day} 00:00:00`;
      const endTime = `${year}-${month}-${day} 23:59:59`;

      const playbackTime = {
        cameraIndexCode: this.cameraIndexCode,
        beginTime: beginTime, // 开始时间
        endTime: endTime, // 结束时间
      };

      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.playbackVideo.startPlayback(playbackTime); // 调用子组件的方法
        }, 2000);
      });
    },
    // 发送开门命令
    // sendOpenDoor(deviceId) {
    //   this.$prompt('请输入系统登录密码确认身份', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     inputType: 'password',
    //   }).then(({value}) => {
    //     passwordVerifiers(value).then(res => {
    //       if (res.data === true) {
    //         setCookie("passwordVerification", '1', null);
    //         openZkDoor(deviceId).then(res => {
    //           if (res.code === 0) {
    //             this.$message.success("控制开门成功")
    //           }else {
    //             this.$message.error("控制开门失败")
    //           }
    //         })
    //       } else {
    //         this.$message({
    //           message: '系统登录密码错误',
    //           type: 'warning'
    //         });
    //         return;
    //       }
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '取消输入'
    //     });
    //   });
    // }
  },
};
</script>

<style scoped></style>
